export default "__VITE_ASSET__6d7426bf__"